export default "__VITE_ASSET__ff46c147__"